(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sidebar-category"]) return;
  try {
    
$(document).ready(function(){
  // Menú expandible para categorías
  $(".dt-menu-expand").click(function(event){
    event.preventDefault();

    if($(this).hasClass("dt-mean-clicked")) {
      $(this).text("+");
      $(this).siblings(".children").slideUp(400).addClass("hidden");
    } else {
      $(this).text("-");
      $(this).siblings(".children").slideDown(400).removeClass("hidden");
    }

    $(this).toggleClass("dt-mean-clicked");
  });
});

  } catch(e) { console.error(e); }
})();
})();
